import { useEffect, useState } from 'react';

/** Default word-rotation cadence (ms). Kept in sync with the `.agent-search-word` CSS pulse. */
export const STATUS_WORD_INTERVAL_MS = 3500;

/**
 * Cycle through a list of status words on a fixed interval (TD-2334 spinner words).
 *
 * Sequential (no RNG) so it is deterministic for tests and never shows the same word twice
 * in a row (for lists of length > 1). The index is intentionally preserved across list /
 * interval changes (only the timer is torn down and recreated); it restarts at the first
 * word only on remount. Returns the current word ('' for an empty list).
 *
 * @param {string[]} words
 * @param {number} [intervalMs=STATUS_WORD_INTERVAL_MS]
 * @returns {string}
 */
export default function useRotatingStatusWord(words, intervalMs = STATUS_WORD_INTERVAL_MS) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!Array.isArray(words) || words.length <= 1) {
      return undefined;
    }
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [words, intervalMs]);

  if (!Array.isArray(words) || words.length === 0) {
    return '';
  }
  return words[index % words.length];
}
